import { FC } from 'react'
import { Image, Typography } from 'antd'
import { cardContainerStyles } from './AuthHeader.styles'

const { Text, Title } = Typography

interface AuthHeaderProps {
  cardContainerStyle?: React.CSSProperties
  imageUrl?: string
  imageStyle?: React.CSSProperties
  title?: string
  titleStyle?: React.CSSProperties
  description?: string
  descriptionStyle?: React.CSSProperties
}

const AuthHeader: FC<AuthHeaderProps> = ({
  cardContainerStyle = cardContainerStyles,
  imageUrl,
  title,
  description,
  descriptionStyle,
  imageStyle,
  titleStyle
}) => {
  return (
    <div style={cardContainerStyle}>
      {imageUrl && <Image style={imageStyle} src={imageUrl} />}
      {title && (
        <Title style={titleStyle} level={3}>
          {title}
        </Title>
      )}
      {description && <Text style={descriptionStyle}>{description}</Text>}
    </div>
  )
}

export default AuthHeader
